import React, { useState, useEffect, useRef, useMemo } from "react";
import PersonIcon from "@mui/icons-material/Person";
import {
  Button,
  Box,
  TextField,
  Checkbox,
  Avatar,
  debounce,
  InputAdornment,
  FormHelperText,
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { avatarBackgroundColors } from "../../../helper/commonFunctions";
import { toast } from "react-toastify";
import axios from "axios";
import SearchedUser from "./SearchedUser";
import { useSelector } from "react-redux";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "14px",
  minWidth: "577px",
  minHeight: "544px",
  border: "none",
};

const InvitedUserComponent = ({
  setFinalInvitedUsers,
  finalInvitedUsers,
  isAdmin,
  formik,
}) => {
  // "";
  const [invitedUsers, setInvitedUsers] = useState(finalInvitedUsers || []);
  const token = useSelector((state) => state.auth.token);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [clicked, setClicked] = useState(false);

  const fetchSearchResult = useMemo(() =>
    debounce((callback, searchValue) => {
      axios
        .get(
          `${process.env.REACT_APP_API_URL_USER}/searchUsers?search=${searchValue}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then((response) => {
          const data = response.data;
          if (data.success) {
            callback(data.data);
          } else {
            toast.error(data.message);
            callback([]);
          }
        })
        .catch((e) => {
          callback([]);
          toast.error("something went wrong");
        });
    }, 400),
  );

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    if (e.target.value === "") {
      // setSearchData([]);
      fetchSearchResult(setSearchData, "");
      return;
    }
    fetchSearchResult(setSearchData, e.target.value);
  };

  useEffect(() => {
    fetchSearchResult(setSearchData, "");
  }, []);

  return (
    <>
      <Box className="invited-user-wrapper">
        <Button
          className="invite-user-btn"
          onClick={() => {
            if (isAdmin) {
              setOpen(true);
            } else {
              toast.error("Only Admin can invite users");
            }
          }}
        >
          <PersonIcon className="user-icon" />
          {finalInvitedUsers && finalInvitedUsers.length > 0
            ? ""
            : "Invite Members"}
        </Button>
        {finalInvitedUsers && finalInvitedUsers.length > 0
          ? finalInvitedUsers.map((user) => (
              <Button className="final-invited-user-btn">
                {user.firstName + " " + user.lastName}
              </Button>
            ))
          : ""}
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box className="invite-user-modal">
            <Box className="invite-user-header">
              <Box className="header-wrapper">
                <Typography component="h2">Invite Members</Typography>
                <ClearIcon
                  className="clear-icon"
                  onClick={() => {
                    setOpen(false);
                  }}
                />
              </Box>
            </Box>
            <Box className="invite-user-content">
              <Box className="search-wrapper">
                <TextField
                  id="outlined-start-adornment"
                  sx={{
                    width: "100%",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "transparent",
                      border: "1px solid rgba(25, 27, 47, 0.1);",
                      borderRadius: "8px",
                      fontFamily: "Arial",
                      fontStyle: "normal",
                      fontWeight: "500",
                      fontSize: "15px",
                      lineHeight: "17px",
                      color: "#191B2F",

                      paddingLeft: { xs: "10px", md: "17px" },
                      "&:hover": {
                        backgroundColor: "transparent",
                        border: "1px solid rgba(25, 27, 47, 0.1);",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "transparent",
                        border: "1px solid rgba(25, 27, 47, 0.1);",
                        outline: "none",
                      },

                      "& .MuiInputBase-input": {
                        padding: { md: "16.5px 14px", xs: "10px 10px" },
                      },
                    },

                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                      "&:hover": {
                        border: "none",
                      },
                    },
                  }}
                  value={search}
                  onChange={handleSearchChange}
                  placeholder="Enter User name or Email"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box className="users">
                {searchData.length > 0
                  ? searchData
                      .filter((user) => user.phone_number)
                      .map((user) => (
                        <SearchedUser
                          user={user}
                          invitedUsers={invitedUsers}
                          setInvitedUsers={setInvitedUsers}
                        />
                      ))
                  : "No user found"}
              </Box>
              <Box
                className="invite-list"
                sx={{
                  display: "flex",
                  gap: "10px",
                  padding: "15px 0",
                  flexWrap: "nowrap",
                  overflowX: "auto",
                  overflowY: "hidden",
                }}
              >
                {invitedUsers && invitedUsers.length > 0
                  ? invitedUsers.map((user) => (
                      <Button className="invited-user-btn">
                        <ClearIcon
                          className="clear-icon"
                          onClick={() => {
                            setInvitedUsers((list) =>
                              list.filter((ele) => ele?.id !== user.id),
                            );
                          }}
                        />
                        <Typography component={"span"}>{user.email}</Typography>
                      </Button>
                    ))
                  : ""}
              </Box>
              <Button
                sx={{ width: "100%" }}
                className="invite-user-btn"
                onClick={() => {
                  setFinalInvitedUsers(invitedUsers);
                  // setSearch("");
                  // setSearchData([]);
                  // setInvitedUsers([]);
                  setOpen(false);
                }}
              >
                Invite
              </Button>
            </Box>
          </Box>
        </Fade>
      </Modal>

      {(clicked && invitedUsers?.length == 0) ||
      (formik.submitCount > 0 && invitedUsers?.length == 0) ? (
        <FormHelperText sx={{ color: "red" }}>
          {`Please invite atlease one member.`}
        </FormHelperText>
      ) : (
        ""
      )}
    </>
  );
};

export default InvitedUserComponent;
